module.exports = [{"componentChunkName":"component---src-pages-index-js","layout":null,"jsonName":"index.json","path":"/"}]


//////////////////
// WEBPACK FOOTER
// ./.cache/pages.json
// module id = 288
// module chunks = 231608221292675